import ScrollToTop from './scroll-to-top';

export default ScrollToTop;